import React from "react";
import "./BeautifulLoader.css";

export const BeautifulLoader = () => {
  return (
    <div className="loader-container">
      <div className="loaderShape"></div>
      <div className="loader"></div>
    </div>
  );
};
